module.exports = __webpack_public_path__ + "static/media/sun-light-summer-solstice.6cb543a3.svg";